<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 mb-20">
                        <h6 class=" float-left mb-0 ml-10 fs-18 fw-700" style="color: #000" *ngIf="cardType != 'switch-card'">FEATURES</h6>
                    </div>
                   
                </div>
                <div class="col-md-12 mb-20 text-start" style="color: black;" *ngIf="cardType == 'switch-multi-card' || cardType == 'switch-card'">
                    <h4 *ngIf="cardType == 'switch-card'" class="features-heading"><b>SMART SWITCH MULTI CURRENCY FEATURES</b></h4>
                    <p>The <b>GlobalPay Smart Switch Forex Card</b> is built for truly borderless payments, bringing the power of <b>30 multi-currencies together in a single card</b>, crafted for global travelers. It eliminates the need to carry multiple cards while giving you the flexibility to spend in local currencies across countries.</p>
                    <p>Accepted in <b>180+ countries</b> and across <b>100 million+ merchant outlets worldwide</b> this prepaid multicurrency card is GlobalPay App-enabled and supports 30 key international currencies: USD, GBP, EUR, CHF, CAD, AUD, SGD, HKD, THB, AED, SAR, ZAR, NZD, JPY, SEK, DKK, MYR, IDR, TRY, QAR, VND, CNY, KWD, OMR, KRW, NOK, PHP, GEL, AZN and ILS.</p>
                </div>              
                <div class="travelpay" *ngIf="cardType == 'switch-multi-card' || cardType == 'switch-card'">
                    <div class="row mt-6">  
                        <div class="col-6 col-sm-4 col-md-3 mb-3" *ngFor="let singleItem of switchMultiFeatureItems"> 
                            <div class="d-flex align-items-center travelpay-section">
                                <img src="assets/images/features-icon/{{singleItem.icon}}" style="width: 70px; height: 70px;">
                                <div class="fs-14 fw-600" >
                                    {{ singleItem.title }}
                                </div>
                            </div>
                        </div>
                    </div>       
                </div>

                <div class="col-md-12 mb-20 text-start" style="color: black;" *ngIf="cardType == 'switch-single-card' || cardType == 'switch-card'">
                    <h4 *ngIf="cardType == 'switch-card'" class="features-heading"><b>SMART SWITCH SINGLE CURRENCY FEATURES</b></h4>                    
                    <p>The <b>GlobalPay Smart Switch Forex Card</b> is the next evolution in international payments crafted to evolve with your journey. It begins with the simplicity and control of a <b>single-currency card</b>, making it ideal for Global travelers.</p>
                    <p class="m-0">Initially loaded in <b>USD</b>, the card lets you spend globally with ease while maintaining the familiarity and predictability of a single currency. </p>
                    <p class="m-0">Accepted in <b>180+ countries</b> and across <b>100 million+ merchant outlets worldwide.</b></p>
                </div>
               
                <div class="travelpay" *ngIf="cardType == 'switch-single-card' || cardType == 'switch-card'">
                    <div class="row mt-6">  
                        <div class="col-6 col-sm-4 col-md-3 mb-3" *ngFor="let singleItem of switchSingleFeatureItems"> 
                            <div class="d-flex align-items-center travelpay-section">
                                <img src="assets/images/features-icon/{{singleItem.icon}}" style="width: 70px; height: 70px;">
                                <div class="fs-14 fw-600" >
                                    {{ singleItem.title }}
                                </div>
                            </div>
                        </div>
                    </div>       
                </div> 


                <div class="col-md-12 mb-20 text-start" style="color: black;" *ngIf="cardType == 'uni-z-card'">            
                    <p>The <b>Uni-Z Digital Card</b> is a simple, digital-only forex card designed for students managing education payments in the pre-travel stage. It offers a quick and convenient alternative to demand drafts, which often involve longer processing times and higher charges.</p>
                    <p class="m-0">With Uni-Z, you skip long banking procedures and make Online Payments instantly to universities, visa portals, exam bodies, and official education services worldwide. Load up to 30 International currencies ( USD, GBP, EUR, CAD, AUD, SGD, AED, SAR, THB, CHF, HKD, ZAR, NZD, JPY, SEK, DKK, MYR, IDR, TRY, QAR, VND, CNY, KWD, OMR, KRW, NOK, PHP, GEL, AZN and ILS.) for secure and convenient fee payments.</p>
                    <!-- <p class="m-0">Accepted in <b>180+ countries</b> and across <b>100 million+ merchant outlets worldwide.</b></p> -->
                </div>
               
                <div class="travelpay" *ngIf="cardType == 'uni-z-card'">
                    <div class="row mt-6">  
                        <div class="col-6 col-sm-4 col-md-3 mb-3" *ngFor="let singleItem of uniZCardFeatureItems"> 
                            <div class="d-flex align-items-center travelpay-section">
                                <img src="assets/images/features-icon/{{singleItem.icon}}" style="width: 70px; height: 70px;">
                                <div class="fs-14 fw-600" >
                                    {{ singleItem.title }}
                                </div>
                            </div>
                        </div>
                    </div>       
                </div> 



                <div class="col-md-6 text-left ">
                    <button  class="btn btn-travelpay" (click)="goToBackPage()">Back</button>
                </div>
            </div>
        </div>
    </div>
</div>